import React from "react";

const LoadingText = ({ text = "" }) => {
  return (
    <span className="d-flex align-items-center justify-content-center">
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      />
      {text}
    </span>
  );
};

export default LoadingText;
